export const contractConstants = {
    STATUS_REQUEST: 'STATUS_LOAD_REQUEST',
    STATUS_SUCCESS: 'STATUS_LOAD_SUCCESS',
    STATUS_FAILURE: 'STATUS_LOAD_FAILURE',

    LOAD_REQUEST: 'CONTRACT_LOAD_REQUEST',
    LOAD_SUCCESS: 'CONTRACT_LOAD_SUCCESS',
    LOAD_FAILURE: 'CONTRACT_LOAD_FAILURE',

    SELECT_REQUEST: 'CONTRACT_SELECT_REQUEST',

    HISTORY_REQUEST: 'CONTRACT_HISTORY_REQUEST',
    HISTORY_SUCCESS: 'CONTRACT_HISTORY_SUCCESS',
    HISTORY_FAILURE: 'CONTRACT_HISTORY_FAILURE',

    KEEP_REQUEST: 'CONTRACT_KEEP_REQUEST',
    KEEP_SUCCESS: 'CONTRACT_KEEP_SUCCESS',
    KEEP_FAILURE: 'CONTRACT_KEEP_FAILURE',
    KEEP_CLOSE: 'CONTRACT_KEEP_CLOSE',

    DELETE_REQUEST: 'CONTRACT_DELETE_REQUEST',
    DELETE_SUCCESS: 'CONTRACT_DELETE_SUCCESS',
    DELETE_FAILURE: 'CONTRACT_DELETE_FAILURE',

    CONFIRM_REQUEST: 'CONTRACT_CONFIRM_REQUEST',
    CONFIRM_SUCCESS: 'CONTRACT_CONFIRM_SUCCESS',
    CONFIRM_FAILURE: 'CONTRACT_CONFIRM_FAILURE',

    SEARCH_REQUEST: 'CONTRACT_SEARCH_REQUEST',
    SEARCH_SUCCESS: 'CONTRACT_SEARCH_SUCCESS',
    SEARCH_FAILURE: 'CONTRACT_SEARCH_FAILURE',

    RECORD_REQUEST: 'CONTRACT_RECORD_REQUEST',
    RECORD_SUCCESS: 'CONTRACT_RECORD_SUCCESS',
    RECORD_FAILURE: 'CONTRACT_RECORD_FAILURE',
    RECORD_CLOSE: 'CONTRACT_RECORD_CLOSE',

    DOWNLOAD_REQUEST: 'CONTRACT_DOWNLOAD_REQUEST',
    DOWNLOAD_SUCCESS: 'CONTRACT_DOWNLOAD_SUCCESS',
    DOWNLOAD_FAILURE: 'CONTRACT_DOWNLOAD_FAILURE',

    DETAILS_REQUEST: 'CONTRACT_DETAILS_REQUEST',
    DETAILS_SUCCESS: 'CONTRACT_DETAILS_SUCCESS',
    DETAILS_FAILURE: 'CONTRACT_DETAILS_FAILURE',
}
